import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Navbar from './components/Navbar';
import SessionList from './components/SessionList';
import SessionDetail from './components/SessionDetail';
import SessionForm from './components/SessionForm';
import ExerciseForm from './components/ExerciseForm';
import InstructionForm from './components/InstructionForm';
import ExerciseDetail from './components/ExerciseDetail';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                    <Navbar />
                    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                        <Routes>
                            <Route path="/" element={<SessionList />} />
                            <Route path="/sessions" element={<SessionList />} />
                            <Route path="/sessions/new" element={<SessionForm />} />
                            <Route path="/sessions/:sessionId/edit" element={<SessionForm />} />
                            <Route path="/sessions/:sessionId/exercises/new" element={<ExerciseForm />} />
                            <Route path="/sessions/:sessionId/exercises/:exerciseId/edit" element={<ExerciseForm />} />
                            <Route path="/sessions/:sessionId/exercises/:exerciseId/instructions/new" element={<InstructionForm />} />
                            <Route path="/sessions/:sessionId/exercises/:exerciseId/instructions/:instructionId/edit" element={<InstructionForm />} />
                            <Route path="/sessions/:sessionId" element={<SessionDetail />} />
                            <Route path="/sessions/:sessionId/exercises/:exerciseId" element={<ExerciseDetail />} />
                        </Routes>
                    </Box>
                </Box>
            </Router>
        </ThemeProvider>
    );
}

export default App; 